var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverlapMarkerImageSrcUnselect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0365 33.6068C16.6107 34.1448 16.2544 34.6615 16 35.0516C15.7456 34.6615 15.3893 34.1448 14.9635 33.6068C14.5237 33.0513 14.0026 32.464 13.4362 31.969C12.8751 31.4786 12.2399 31.0525 11.5696 30.8577C5.16748 28.9516 0.5 23.0202 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 23.0202 26.8325 28.9516 20.4303 30.8577C19.7601 31.0525 19.1249 31.4786 18.5638 31.969C17.9974 32.464 17.4763 33.0513 17.0365 33.6068Z",
    fill: "white",
    stroke: "#6F7282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 13.9757C16.7455 13.9757 17.3499 14.5802 17.3499 15.3257C17.3499 16.0713 16.7455 16.6757 15.9999 16.6757C15.2543 16.6757 14.6499 16.0713 14.6499 15.3257C14.6499 14.5802 15.2543 13.9757 15.9999 13.9757Z",
    fill: "#6F7282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 9.92574C16.7455 9.92574 17.3499 10.5302 17.3499 11.2757C17.3499 12.0213 16.7455 12.6257 15.9999 12.6257C15.2543 12.6257 14.6499 12.0213 14.6499 11.2757C14.6499 10.5302 15.2543 9.92574 15.9999 9.92574Z",
    fill: "#6F7282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 18.0257C16.7455 18.0257 17.3499 18.6302 17.3499 19.3757C17.3499 20.1213 16.7455 20.7257 15.9999 20.7257C15.2543 20.7257 14.6499 20.1213 14.6499 19.3757C14.6499 18.6302 15.2543 18.0257 15.9999 18.0257Z",
    fill: "#6F7282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlapMarkerImageSrcUnselect);
export default __webpack_public_path__ + "static/media/overlapMarkerImageSrc_unselect.788c466dc73ef9de5d627588f13bc541.svg";
export { ForwardRef as ReactComponent };